/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React, { Component } from "react";
import CheckBox from "../checkbox";
import InputField from "../input-field";
import { getPreFillDataByContentKey } from "../../../utils/userResponse";
import _ from "lodash";
// Interface for Dropdown With Checkbox Props
interface DropdownWithCheckboxProps {
  list: any;
  dropdown_title: string;
  dropdown_placeHolder?: string;
  inputType?: string;
  inputValue: (evt: any) => void;
  isError: boolean;
  handleCheckboxClick?: any;
  isDisabled?: boolean;
  recoId?: any;
  contentTypeId?: any;
  nonListCheckboxClick?: any;
}

// Interface for Dropdown With Checkbox State
interface DropdownWithCheckboxState {
  inputValue: any;
  errorMsg?: string;
  openList: boolean;
  dropdownList: any;
  selectedIndex: string | number;
}

/**
 * Dropdown With Checkbox Component
 *
 * @namespace DropdownWithCheckbox
 */

class DropdownWithCheckbox extends Component<
  DropdownWithCheckboxProps,
  DropdownWithCheckboxState
> {
  node: any;
  myRef: any;
  constructor(props: any) {
    super(props);
    this.myRef = React.createRef();
    // this.node = React.createRef();
    this.state = {
      openList: false,
      inputValue: "",
      dropdownList: this.props && this.props.list,
      selectedIndex: "",
    };
  }
  componentDidMount = () => {
    let recoValuesData: any = getPreFillDataByContentKey(
      this.props.contentTypeId
    );
    if (recoValuesData && !_.isEmpty(recoValuesData)) {
      this.setPreFillData(recoValuesData);
    }
  };
  componentDidUpdate() {
    if (this.props.list !== this.state.dropdownList) {
      //this.node && this.node.scrollTo(0, 0);
      this.setState({ dropdownList: this.props.list, inputValue: "" });
      let recoValuesData: any = getPreFillDataByContentKey(
        this.props.contentTypeId
      );
      if (recoValuesData && !_.isEmpty(recoValuesData)) {
        this.setPreFillData(recoValuesData);
      }
    }
  }

  /**
   * Used to set data as per users input(existing- if any)
   */
  setPreFillData = (recoValuesData: any) => {
    const data: any = this.props.list;
    if (_.isEmpty(recoValuesData?.recoValues)) {
      const evt: any = {
        target: {
          checked: true,
        },
      };
      this.props.nonListCheckboxClick(evt);
    } else {
      _.map(data, (item: any, index: any) => {
        if (_.includes(recoValuesData.recoValues, item.id)) {
          item.isChecked = true;
        } else {
          item.isChecked = false;
        }
      });
      this.setState({ dropdownList: data });
      const evt: any = {
        target: {
          checked: false,
        },
      };
      this.props.nonListCheckboxClick(evt);
    }
  };

  /**
   * This method is used for handle dropdown functionality
   *
   */
  handleDropDown = (e: any) => {
    e.stopPropagation();
    if (this.state.openList === false) {
      this.setState({ openList: true });
    }

    document.addEventListener("click", this.handleOutsideClick);
    document.addEventListener("keydown", (e: any) => {
      if (e.key === "Escape") {
        this.handleOutsideClick(e);
      }
    });

    // if (this.state.openList) {
    //   // attach/remove event handler
    //   document.addEventListener("click", this.handleOutsideClick);
    //   document.addEventListener("keydown", (e: any) => {
    //     if (e.key === "Escape") {
    //       this.handleOutsideClick(e);
    //     }
    //   });
    // } else {
    //   document.removeEventListener("click", this.handleOutsideClick);
    //   //document.removeEventListener("keydown", (e: any) => { if (e.key === "Escape") { this.handleOutsideClick(e) } })
    // }

    // this.setState((prevState) => ({
    //   openList: !prevState.openList,
    // }));
  };

  /**
   * This method is used for handling dropdown outside click
   * @param {object} e
   *
   */
  handleOutsideClick = (e: any) => {
    e.stopPropagation();

    this.node && this.node.scrollTo(0, 0);
    this.setState({
      openList: false,
      inputValue: "",
    });
    // ignore clicks on the component itself
    if (this.node && this.node.contains(e.target)) {
      return;
    }
  };

  /**
   * This method is used handling input change
   * @param {any} evt
   */
  handleDropDownSearch = (evt: any) => {
    this.setState(
      {
        ...this.state,
        inputValue: evt.target.value,
        //openList: true,
      },
      () => {
        this.props.inputValue(evt);
      }
    );
  };

  render() {
    const {
      inputType,
      dropdown_title,
      dropdown_placeHolder,
      isError,
      isDisabled,
    } = this.props;
    const { inputValue, dropdownList } = this.state;

    const filterDropdownData =
      inputValue && inputValue.trim() && inputValue.trim().length > 2
        ? dropdownList.filter(
            (item: any) =>
              item &&
              item.name.toLowerCase() &&
              item.name
                .toLowerCase()
                .indexOf(
                  inputValue.trim() && inputValue.trim().toLowerCase()
                ) !== -1
          )
        : dropdownList;

    return (
      <div
        className={
          isDisabled
            ? "input-wrapper dropdown-container dropdown-with-checkbox disable"
            : "input-wrapper dropdown-container dropdown-with-checkbox"
        }
      >
        <div className="dropdown-label">{dropdown_title || ""}</div>
        <div className="option-wrapper" onClick={this.handleDropDown}>
          <InputField
            type={inputType || "text"}
            placeHolder={dropdown_placeHolder || ""}
            className={isError ? "custom-input error-input" : "custom-input"}
            handleInputChange={(evt) => {
              this.handleDropDownSearch(evt);
            }}
            inputValue={inputValue || ""}
            errorMsg={""}
            //autoFocusOnInput
          />
          <div className={"icon search-icon"}></div>
        </div>

        {/* dropdown list shown here */}
        <div
          id="drop"
          className={this.state.openList ? "dropdown-options" : "hide"}
          ref={(node) => {
            this.node = node;
          }}
          // ref={this.myRef}
        >
          {filterDropdownData && filterDropdownData.length > 0
            ? filterDropdownData.map((item: any, index: number) => (
                <div
                  key={index}
                  tabIndex={0}
                  role="menuitemcheckbox"
                  aria-checked={item.isChecked}
                  className={
                    item && item.isChecked
                      ? "dropdown-value-wrapper active"
                      : "dropdown-value-wrapper"
                  }
                  onClick={(event) => {
                    event?.stopPropagation();
                    this.props.handleCheckboxClick(
                      item && !item.isChecked,
                      item && item.name
                    );
                  }}
                  onKeyPress={(e) => {
                    e?.stopPropagation();
                    if (e.key === "Enter" || e.key === " ") {
                      this.props.handleCheckboxClick(
                        item && !item.isChecked,
                        item && item.name
                      );
                    }
                  }}
                >
                  <div className="dropdown-value input-wrapper">
                    {item && item.name}
                  </div>

                  <CheckBox
                    className={"checkbox"} // Add checkbox-error class for showing error
                    onCheckboxClick={(event) => {
                      event?.stopPropagation();
                      this.props.handleCheckboxClick(
                        event.target.checked,
                        item && item.name
                      );
                    }}
                    isChecked={item && item.isChecked}
                  />
                </div>
              ))
            : null}
        </div>
      </div>
    );
  }
}

export default DropdownWithCheckbox;
